export default __webpack_public_path__ + "static/media/TT.740c30e3.svg";